import React from "react";
import PropTypes from "prop-types";
import * as ICONS from "Components/Icons";
import { Button } from "Components/Base/Inputs/Button";

const ChecklistHeader = (props) => {
  const add_task = props.languageContext("addtask");
  const copy_task_from_activity = props.languageContext(
    "copytasksfromotheractivity",
  );
  const delete_selected_tasks = props.languageContext("deleteselectedtasks");
  const { showCopy, showDelete } = props;

  return (
    <div className="flex flex-end flex-wrap">
      <Button
        endIcon={props.showButtonIcons && <ICONS.ADD size={22} />}
        onClick={props.onAdd}
        label={add_task}
      />
      &nbsp;
      {showCopy && (
        <Button
          endIcon={props.showButtonIcons && <ICONS.COPY size={22} />}
          onClick={props.onCopy}
          label={copy_task_from_activity}
        />
      )}
      &nbsp;
      {showDelete && (
        <Button
          endIcon={props.showButtonIcons && <ICONS.REMOVE size={22} />}
          onClick={props.onDelete}
          label={delete_selected_tasks}
        />
      )}
    </div>
  );
};

ChecklistHeader.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onCopy: PropTypes.func,
  onDelete: PropTypes.func,
  languageContext: PropTypes.func.isRequired,
  showCopy: PropTypes.bool,
  showDelete: PropTypes.bool,
  showButtonIcons: PropTypes.bool,
};

ChecklistHeader.defaultProps = {
  onAdd: () => {},
  onCopy: () => {},
  onDelete: () => {},
  languageContext: () => {},
  showCopy: false,
  showDelete: false,
  showButtonIcons: true,
};

export default ChecklistHeader;
